import { useMemo } from 'react';
import { useRouter } from 'next/router';

export type AppOsType = 'iOS' | 'Android';
export type WebOsType = 'mWebIOS' | 'mWebAndroid' | 'Web';
export type OsType = AppOsType | WebOsType;

export interface UsePlatformInfoReturn {
  osType: OsType;
  appVersion: string | null;
  isMobile: boolean;
  isInApp: boolean;
}

/**
 * 유저의 플랫폼 정보를 반환합니다.
 */
export const usePlatformInfo = (): UsePlatformInfoReturn => {
  const router = useRouter();

  const { os_type: appOsType, version } = router.query;
  const osType: OsType = useMemo(() => {
    const rtn = appOsType as AppOsType;
    if (typeof window === 'undefined' || rtn) {
      return rtn;
    }

    if (sessionStorage['os_type']) {
      return sessionStorage['os_type'] as AppOsType;
    }

    if (
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) ||
      /iPhone|iPad|iPod/i.test(navigator.userAgent)
    ) {
      return 'mWebIOS';
    } else if (/Android/i.test(navigator.userAgent)) {
      return 'mWebAndroid';
    } else {
      return 'Web';
    }
  }, [appOsType]);

  const appVersion: string | null = useMemo(() => {
    if (typeof window === 'undefined' || version) return version;
    return sessionStorage['os_version'] ?? null;
  }, [version]);

  return {
    osType,
    appVersion,
    isMobile: osType !== 'Web',
    isInApp: osType === 'iOS' || osType === 'Android',
  };
};
